export default __webpack_public_path__ + "media/images/react_icons/arrow_right_gray-83b9e890e13676c4df859c7e936ea816.svg";